module.exports = __webpack_public_path__ + "img/menu.7b42ca6e.svg";